import script from "./GrowthContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./GrowthContacts.vue?vue&type=script&setup=true&lang=js"

import "./GrowthContacts.vue?vue&type=style&index=0&id=38b6224a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b6224a"]])

export default __exports__